import i18n from "@/i18n";
import { Button } from "@/components/ui/button";

// Clock In: confirm the actual working start against the published shift.
// mode "ask": Yes / No — different time / Cancel. mode "pick": choose start.
export function ClockInStartDialog({ flow, pick, onPick, pending, onYes, onDifferent, onSubmit, onCancel }) {
    const valid = (flow.options || []).some((o) => o.value === pick);
    return (
        <div
            data-testid="employee-workforce-clock-in-start"
            role="dialog"
            aria-modal="true"
            className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 p-4"
        >
            <div className="w-full max-w-sm rounded-t-2xl sm:rounded-2xl bg-white p-4 space-y-3 shadow-xl">
                {flow.mode === "ask" ? (
                    <>
                        <h3 data-testid="employee-workforce-clock-in-start-title"
                            className="text-base font-medium text-neutral-900">
                            {i18n.t("wf.clockInStartDialog.didYouStartAt", "Did you start at your scheduled time — {{time}}?", { time: flow.startTime })}
                        </h3>
                        <div className="flex flex-col gap-2 pt-1">
                            <Button data-testid="employee-workforce-clock-in-start-yes" onClick={onYes}
                                disabled={pending} className="min-h-[44px]">
                                {i18n.t("wf.clockInStartDialog.yesStartedAt", "Yes, started at {{time}}", { time: flow.startTime })}
                            </Button>
                            <Button variant="outline" data-testid="employee-workforce-clock-in-start-no"
                                onClick={onDifferent} disabled={pending} className="min-h-[44px]">
                                {i18n.t("wf.clockInStartDialog.noDifferentTime", "No — different time")}
                            </Button>
                            <Button variant="ghost" data-testid="employee-workforce-clock-in-start-cancel"
                                onClick={onCancel} disabled={pending} className="min-h-[44px]">
                                {i18n.t("common.cancel", "Cancel")}
                            </Button>
                        </div>
                    </>
                ) : (
                    <>
                        <h3 data-testid="employee-workforce-clock-in-start-title"
                            className="text-base font-medium text-neutral-900">
                            {i18n.t("wf.clockInStartDialog.whenDidYouActuallyStartWorking", "When did you actually start working?")}
                        </h3>
                        <select
                            data-testid="employee-workforce-clock-in-start-picker"
                            className="w-full rounded-md border border-neutral-200 bg-white px-3 py-2 text-sm min-h-[44px]"
                            value={pick}
                            onChange={(e) => onPick(e.target.value)}
                        >
                            {(flow.options || []).map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                            ))}
                        </select>
                        <div className="flex gap-2 pt-1">
                            <Button variant="outline" data-testid="employee-workforce-clock-in-start-pick-cancel"
                                onClick={onCancel} disabled={pending} className="flex-1 min-h-[44px]">
                                {i18n.t("common.cancel", "Cancel")}
                            </Button>
                            <Button data-testid="employee-workforce-clock-in-start-submit" onClick={onSubmit}
                                disabled={pending || !valid} className="flex-1 min-h-[44px]">
                                {i18n.t("wf.clockInStartDialog.clockIn", "Clock in")}
                            </Button>
                        </div>
                    </>
                )}
                {flow.error && (
                    <p data-testid="employee-workforce-clock-in-start-error" role="alert"
                        className="text-sm text-red-700">{flow.error}</p>
                )}
            </div>
        </div>
    );
}
